import React from "react";
import { TableCell, TableRow } from "@material-ui/core";
import { IManagementStore } from "Stores/Management/types";
import { Values } from "Tools/Values";
import { observer, inject } from "mobx-react";
import { observable, computed } from "mobx";
import { IValuesStore } from "@src/Stores/Values/types";
import People from "@material-ui/icons/People";
import moment from "moment";
import CrewPersonModal from "../CrewPersonModal/CrewPersonModal";
import { Location } from "@src/Interfaces/Entity/Location";
import { CrewPosition } from "@src/Interfaces/Entity/Crew";
import { STTableCellTypography } from "@src/Components/Ui/STTableCellTypography";
import { IAuthStore } from "@src/Stores/Auth/types";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
  auth?: IAuthStore;
  location: Location;
  position: CrewPosition;
  values?: IValuesStore;
  management?: IManagementStore;
}

interface IState {
  isPersonModalOpened: boolean;
}

@inject("auth", "values", "management")
@observer
export default class CrewTableContent extends React.Component<IProps, IState> {
  @observable isPersonModalOpened: boolean = false;

  handlePersonModalOpen = () => {
    this.isPersonModalOpened = !this.isPersonModalOpened;
  };
  
  @computed get getCurrentTimeZoneOffset() {
    return this.props.auth.user.location.timeZone;
  }

  getLocaleDate = (date: Date | string) => {
    return this.getCurrentTimeZoneOffset
      ? moment(date).utc().tz(this.getCurrentTimeZoneOffset).format("YYYY-MM-DD HH:mm")
      : moment(date).utc().format("YYYY-MM-DD HH:mm");
  };

  getAssignedSince = (date: Date | string) => {
    let resultString = "";
    const duration = moment.duration(
      this.getCurrentTimeZoneOffset
        ? moment().utc().tz(this.getCurrentTimeZoneOffset).diff(date)
        : moment().utc().diff(date)
    );
    const months = duration.months();
    if (months !== 0) {
      resultString += `${months}${Values.getLocalizationValue("months")} `;
    }
    const days = duration.days();
    if (days !== 0) {
      resultString += `${days}${Values.getLocalizationValue("days")} `;
    }
    const hours = duration.hours();
    if (hours !== 0) {
      resultString += `${hours}${Values.getLocalizationValue("hours")} `;
    }
    const minutes = duration.minutes();
    if (minutes !== 0) {
      resultString += `${minutes}${Values.getLocalizationValue("minutes")}`;
    }
    return resultString;
  };

  render() {
    const { position, location } = this.props;
    return (
      <>
        <TableRow hover key={position.id}>
          <TableCell size="small">
            <STTableCellTypography>{position.name}</STTableCellTypography>
          </TableCell>
          <TableCell size="small">
            <STTableCellTypography>{position.activelyAssignetPersonName}</STTableCellTypography>
          </TableCell>
          <TableCell size="small">
            <STTableCellTypography>
              {position.activelyAssignetPersonName && position.activelyAssignedSince && (
                <>
                  <div>
                    {`${this.getAssignedSince(position.activelyAssignedSince)} (${this.getLocaleDate(
                      position.activelyAssignedSince
                    )})`}
                  </div>
                  <div>{Values.getLocalizationValue("handedOverBy").replace("{0}", position.switchedByName)}</div>
                </>
              )}
            </STTableCellTypography>
          </TableCell>
          <TableCell align="center" size="small">
            <RoundButton
                icon={<People/>}
                tooltipTitle={Values.getLocalizationValue("persons")}
                onClick={() => this.handlePersonModalOpen()}
            />
          </TableCell>
        </TableRow>
        {this.isPersonModalOpened && (
          <CrewPersonModal
            position={position}
            location={location}
            opened={this.isPersonModalOpened}
            handleClose={this.handlePersonModalOpen}
          />
        )}
      </>
    );
  }
}
